var _rect, _rect2, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    role: "img",
    "aria-label": "Product image placeholder",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "#e8eaf0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 80,
    width: 640,
    height: 640,
    fill: "none",
    stroke: "#c5cad6",
    strokeWidth: 4,
    strokeDasharray: "16 12"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#9aa3b5",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 280,
    width: 280,
    height: 220,
    rx: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 350,
    r: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 460l70-70 50 50 60-80 80 100H280z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 560,
    textAnchor: "middle",
    fill: "#6b7385",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 28
  }, "Product image")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductPlaceholder);
export default __webpack_public_path__ + "static/media/product-placeholder.8fcc78674c662a1f291a320744ef89bb.svg";
export { ForwardRef as ReactComponent };